export const CHECK_ELEMENT = "check-item";
export const CHECK_LIST_ELEMENT = "check-list";
